import type { CeoExecutiveAlert } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import {
  AlertArrow,
  AlertCard,
  AlertDesc,
  AlertsGrid,
  AlertTitle,
  AlertTop,
  Section,
  SectionHeader,
  SectionTitle,
} from './styles';

interface AlertsRadarSectionProps {
  alerts: CeoExecutiveAlert[];
}

export function AlertsRadarSection({ alerts }: AlertsRadarSectionProps) {
  if (alerts.length === 0) return null;

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Управленческий радар и сигналы дня</SectionTitle>
      </SectionHeader>
      <AlertsGrid>
        {alerts.map((a) => {
          const toPath =
            a.target_tab === 'debts'
              ? '/agents/ceo/debts'
              : a.target_tab === 'inflows'
                ? '/agents/ceo/inflows'
                : a.target_tab === 'approvals'
                  ? '/agents/ceo/approvals'
                  : '/agents/ceo/accounts';
          return (
            <AlertCard key={a.code} to={toPath} $severity={a.severity}>
              <AlertTop>
                <Badge
                  $tone={
                    a.severity === 'critical'
                      ? 'danger'
                      : a.severity === 'warning'
                        ? 'warning'
                        : 'info'
                  }
                >
                  {a.metric_value}
                </Badge>
                <AlertArrow>Перейти →</AlertArrow>
              </AlertTop>
              <AlertTitle>{a.title}</AlertTitle>
              <AlertDesc>{a.description}</AlertDesc>
            </AlertCard>
          );
        })}
      </AlertsGrid>
    </Section>
  );
}
